
define('tmpl!core/templates/webidl/interface.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlInterface\' id=\'{{id}}\'>{{extAttr obj indent true ctor\n}}{{idn indent}}{{partial}}{{callback}}interface <span class=\'idlInterfaceID\'>{{obj.id}}</span>{{superclasses obj}} &#123;\n{{{children}}}{{idn indent}}&#125;;</span>');});

